import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";

import { getModels } from "../../../Api/services/ai";

/**
 *
 * @param {Object} props
 * @param {string} props.value
 * @param {Function} props.onChange
 */
export const ModelSelector = (props) => {
	/**
	 * Fetch available models.
	 */
	const { data, isLoading } = useQuery({
		queryKey: ["ai-models"],
		queryFn: () => getModels(),
	});

	const models = (data ?? []).map((model) => ({
		value: model,
		label: model,
	}));

	return (
		<Select
			value={props.value}
			onChange={props.onChange}
			options={models}
			isSearchable
			isClearable
			isLoading={isLoading}
			placeholder="Select a prompt"
		/>
	);
};
